import * as dat from 'dat.gui';

class DatGUI
{
  constructor()
  {
    this.dat_gui = undefined;

    this.settings = {
      turbidity: 10.6,
      rayleigh: 0.815,
      mieCoefficient: 0.008,
      mieDirectionalG: 0.948,
      elevation: 61,
      azimuth: -139,
      exposure: 0.5,
    };
  }

  init()
  {
    document.addEventListener('keydown', event =>
    {
      if (event.shiftKey && event.key === 'K')
      {
        document.querySelector('.dg.ac').classList.toggle('hidden');
      }
    });
  }

  start()
  {
    this.dat_gui = new dat.GUI();

    document.querySelector('.dg.ac').style['z-index'] = 999;
    document.querySelector('.dg.ac').classList.add('hidden');

    this.dat_gui.add( this.settings, 'turbidity', 0.0, 20.0, 0.1 );
    this.dat_gui.add( this.settings, 'rayleigh', 0.0, 4, 0.001 );
    this.dat_gui.add( this.settings, 'mieCoefficient', 0.0, 0.1, 0.001 );
    this.dat_gui.add( this.settings, 'mieDirectionalG', 0.0, 1, 0.001 );
    this.dat_gui.add( this.settings, 'elevation', 0, 90, 0.1 );
    this.dat_gui.add( this.settings, 'azimuth', - 180, 180, 0.1 );
    this.dat_gui.add( this.settings, 'exposure', 0, 1, 0.05 );

    this.dat_gui.width = 400;
  }
}

export default new DatGUI();
